import { render, staticRenderFns } from "./GarageForm.vue?vue&type=template&id=a15f3528"
import script from "./GarageForm.vue?vue&type=script&lang=js"
export * from "./GarageForm.vue?vue&type=script&lang=js"
import style0 from "./GarageForm.vue?vue&type=style&index=0&id=a15f3528&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports